export const locations = state => {
  let temp = state.activityDetail
  let statuses = temp.statuses

  if (!temp.customer_location) {
    temp.customer_location = {
      latitude: -7.7831651,
      longitude: 110.3696965
    }
  }

  let data = []

  data.push({
    name: temp.customer_name,
    position: [temp.customer_location.latitude, temp.customer_location.longitude]
  })

  if (Array.isArray(statuses) && statuses.length) {
    statuses.forEach(status => {
      if (!status.location) {
        status.location = {
          latitude: 0,
          longitude: 0
        }
      }

      let loc = {
        name: status.status,
        position: [status.location.latitude, status.location.longitude]
      }

      data.push(loc)
    })
  }

  return data
}

export const todayMapBy = state => val => {
  let data = []

  if (val && Array.isArray(state.today.maps) && state.today.maps.length)
    state.today.maps.forEach(map => {
      if (map.assignee_id == val) data.push(map)
    })
  else data = state.today.maps

  return data
}

export const dailyList = state => {
  let temps = state.listDailyActivityType
  let lists = []

  if (Array.isArray(temps) && temps.length) {
    temps.forEach(temp => {
      lists.push({
        id: temp.id,
        label: temp.name
      })
    })
  }

  return lists
}
